import { useMemo } from "react"
import { ProductStockInfo } from "../../../modules/merchant/admin/products/productsTypes"
import { checkProductStock, getMaxQuantity, getProductLeftCount } from "./stockHelpers"

type ProductStockResult = Readonly<{
    maxQuantity: number | undefined
    isSoldOut: boolean
    productsLeftCount: number | undefined
    disableIncrease: boolean
    validateQuantity: (quantity: number) => { allowed: boolean; reason: "daily-limit" | "stock-limit" | null }
}>

type UseProductStockParams = {
    stock: ProductStockInfo | undefined
    currentQuantity: number
    isUnavailable?: boolean
}

export function useProductStock({
    stock,
    currentQuantity,
    isUnavailable = false,
}: UseProductStockParams): ProductStockResult {
    return useMemo(() => {
        const maxQuantity = getMaxQuantity(stock)
        const productsLeftCount = getProductLeftCount(stock)
        const isSoldOut = maxQuantity !== undefined && maxQuantity <= 0
        const disableIncrease = isUnavailable || (maxQuantity !== undefined && currentQuantity >= maxQuantity)

        const validateQuantity = (quantity: number) => {
            const result = checkProductStock(stock, quantity)
            return { allowed: result.allowed, reason: result.reason }
        }

        return {
            maxQuantity,
            isSoldOut,
            productsLeftCount,
            disableIncrease,
            validateQuantity,
        }
    }, [stock, currentQuantity, isUnavailable])
}
